import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _Tooltip from 'rc-tooltip';
import styled from '@emotion/styled';
import { ClassNames, css } from '@emotion/react';
import { memo } from 'react';
const Tooltip = _Tooltip.default || _Tooltip;
import { useShadowDOM } from '@astrumu/core-ui-shadow-dom';
import { useStylesheetAttachment } from '../../../hooks/index.js';
import stylesheet from 'rc-tooltip/assets/bootstrap.css';
const lightPaletteStyles = css({
    fontSize: '1.2rem',
    lineHeight: 1.5,
    opacity: '1 !important',
    width: '100%',
    maxWidth: 'calc(100% - 80px)',
    margin: '0 auto',
    '@media screen and (min-width: 768px)': {
        maxWidth: 'initial',
        margin: 0,
        width: 'initial'
    },
    '& .rc-tooltip-content': {
        padding: '15px 20px',
        borderRadius: 5,
        background: '#fff',
        color: '#fff',
        '& .rc-tooltip-inner': {
            background: '#fff',
            boxShadow: 'none'
        }
    },
    '&.rc-tooltip-placement-top .rc-tooltip-arrow': {
        bottom: '4px !important',
        borderRightColor: '#fff !important'
    },
    '&.rc-tooltip-placement-right .rc-tooltip-arrow': {
        left: '4px !important',
        borderRightColor: '#fff !important'
    }
});
const darkPaletteStyles = css({
    opacity: '1 !important',
    '& .rc-tooltip-inner': {
        backgroundColor: '#2F3D46'
    },
    '&.rc-tooltip-placement-bottom .rc-tooltip-arrow': {
        top: '4px !important'
    },
    '&.rc-tooltip-placement-top .rc-tooltip-arrow': {
        bottom: '4px !important'
    },
    '&.rc-tooltip-placement-left .rc-tooltip-arrow': {
        right: '4px !important'
    },
    '&.rc-tooltip-placement-right .rc-tooltip-arrow': {
        left: '4px !important'
    }
});
const Container = styled.div({
    maxWidth: 350,
    '& .rc-tooltip-arrow': {
        left: '4px !important'
    }
});
const TooltipContainer = memo(({ palette = 'dark', children, renderContent, ...rest }) => {
    useStylesheetAttachment(stylesheet);
    const { root, isShadowDOM } = useShadowDOM();
    return (_jsx(ClassNames, { children: ({ css: cssClassName }) => (_jsx(Tooltip, { ...rest, destroyTooltipOnHide: true, arrowContent: true, overlay: () => (_jsx(Container, { className: "ignoreClickOutside", children: renderContent() })), overlayClassName: palette === 'light'
                ? cssClassName(lightPaletteStyles)
                : cssClassName(darkPaletteStyles), getTooltipContainer: () => isShadowDOM ? root : document.body, children: children })) }));
});
export default TooltipContainer;
//# sourceMappingURL=index.js.map